<template>
  <b-table v-bind="tableAttributes" :fields="fields" :items="items" class="border mt-4">
    <template #cell(name)="data">
      <router-link class="text-decoration-none product-name"
                   :to="{ name: 'Product', params: { name: data.item.product.raw_link } }">
        {{ data.item.product.name }}
      </router-link>
      <p>{{ productName(data.item) }}</p>
    </template>

    <template #cell(quantity)="data">
      {{ data.item.quantity }}
    </template>

    <template #cell(price)="data">
      {{ formatNumber(parseInt(data.item.price) - parseInt(data.item.offer_on_product)) }}
    </template>

    <template #cell(total)="data">

      {{ formatNumber(data.item.subtotal) }}

    </template>


  </b-table>
</template>

<script>
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {productName} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";

export default {
  name: "tablePaidItems",
  props: ["items"],
  data() {
    return {
      tableAttributes,
      fields: [
        {key: "name", label: "نام"},
        {key: "quantity", label: "تعداد"},
        {key: "price", label: "قیمت"},
        {key: "total", label: "جمع کل"},
      ],
    };
  },
  methods: {
    formatNumber,
    productName
  },
};
</script>

<style scoped>
.product-name, .product-name:hover {
  color: black;
}

</style>